import React from "react";
import useAssets from "../../hooks/useAssets";
import useTheme from "../../hooks/useTheme";

const FaceRateSlider = ({
  rate,
  width = 125,
  height = 25,
  iconSize = 22,
  showRateText = false,
  largeText = false,
}) => {
  const theme = useTheme();
  const { faceAngry, faceSad, faceNeutral, faceHappy, faceLol } = useAssets();
  const icons = [
    faceAngry,
    faceSad,
    faceNeutral,
    faceHappy,
    faceLol,
  ];

  if (!rate) return null;

  const value = rate || 0;
  const widthValue = width + 10;
  const progressWidth = (value / icons.length) * widthValue;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Progress Bar */}
      <div
        style={{
          position: "relative",
          width: `${widthValue}px`,
          height: `${height}px`,
          backgroundColor: "rgba(200, 200, 200, 0.3)",
          borderRadius: "99px",
          overflow: "hidden",
        }}
      >
        {/* Progress Fill */}
        {value > 0 && (
          <div
            style={{
              width: `${progressWidth}px`,
              height: "100%",
              backgroundColor: theme.primaryColor,
              borderRadius: "99px",
            }}
          ></div>
        )}

        {/* Icons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: "0 6px",

          }}
        >
          {icons.map((icon, index) => (
            <img
              key={index}
              src={icon}
              alt={`Rating Icon ${index + 1}`}
              loading="lazy"
              style={{
                height: `${height}px`,
                marginRight: index < icons.length - 1 ? "4px" : "0",
                filter: "brightness(0) invert(1)", // Ensures icons are white
              }}
            />
          ))}
        </div>
      </div>

      {/* Rate Text */}
      {showRateText && (
        <span
          style={{
            marginLeft: "10px",
            fontSize: largeText ? "18px" : "14px",
            fontWeight: largeText ? "bold" : "normal",
          }}
        >
          {rate.toFixed(2)}
        </span>
      )}
    </div>
  );
};

export default FaceRateSlider;